import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { access_token, user } = await adminLogin(email, password);
      login(access_token, user);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid email or password");
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls = "w-full bg-transparent border border-vm-border text-vm-text placeholder:text-vm-muted px-4 py-3.5 text-sm focus:border-vm-accent transition-colors duration-300 rounded-none";

  return (
    <div className="min-h-screen bg-vm-bg flex items-center justify-center px-6" data-testid="login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-10">
          <div className="font-serif text-3xl tracking-[0.25em]">VELMONTÉ</div>
          <p className="vm-label mt-3">Operations · Private Access</p>
        </div>

        <form onSubmit={submit} className="border border-vm-border p-8 md:p-10" data-testid="login-form">
          <div className="w-11 h-11 border border-vm-border flex items-center justify-center mb-8">
            <Lock strokeWidth={1} size={18} className="text-vm-accent" />
          </div>
          <label className="vm-label block mb-2">Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls + " mb-5"} placeholder="you@velmonte.com" data-testid="login-email-input" required />
          <label className="vm-label block mb-2">Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls + " mb-8"} placeholder="••••••••" data-testid="login-password-input" required />
          <button type="submit" disabled={submitting} className="vm-btn-primary w-full py-4 text-xs tracking-[0.2em] uppercase disabled:opacity-50" data-testid="login-submit-button">
            {submitting ? "…" : "Enter"}
          </button>
        </form>

        <Link to="/" className="mt-8 flex items-center justify-center gap-2 text-xs tracking-widest uppercase text-vm-muted hover:text-vm-text transition-colors" data-testid="login-back-link">
          <ArrowLeft strokeWidth={1.5} size={14} /> Back to site
        </Link>
      </motion.div>
    </div>
  );
}
